import { NgModule } from '@angular/core';

import { SharedModule } from "../../shared/shared.module";
import { CombustivelApiService } from "./shared/combustivel-api.service";
import { CombustivelNavigationService } from "./shared/combustivel-navigation.service";
import { CombustivelListComponent } from "./combustivel-list/combustivel-list.component";
import { CombustivelService } from "./shared/combustivel.service";
import { CombustiveisRoutingModule } from "./combustiveis-routing.module";
import { CombustivelFormComponent } from "./combustivel-form/combustivel-form.component";
import { CombustiveisComponent } from "./combustiveis.component";

@NgModule({
  imports: [
    SharedModule,
    CombustiveisRoutingModule
  ],
  providers:[
    CombustivelApiService,
    CombustivelNavigationService,
    CombustivelService
  ],
  declarations: [
    CombustiveisComponent,
    CombustivelListComponent,
    CombustivelFormComponent
  ]
})
export class CombustiveisModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/combustiveis/combustiveis.module.ts
 **/